import React from "react";
import { CompilationErrorComponent } from "./CompilationErrorComponent";
import { CodeValidationResultComponent } from "./CodeValidationResultComponent";
import {
    instanceOfCodeValidationResult,
    instanceOfCompilationError,
    ValidationResult,
} from "../../../data/ValidationResult";

interface ValidationResultComponentProps {
    validationResult: ValidationResult;
}

export function ValidationResultComponent(
    props: ValidationResultComponentProps
) {
    const { validationResult } = props;

    if (instanceOfCodeValidationResult(validationResult)) {
        return (
            <CodeValidationResultComponent
                validationResult={validationResult}
            />
        );
    } else if (instanceOfCompilationError(validationResult)) {
        return <CompilationErrorComponent error={validationResult} />;
    } else {
        console.error("Unexpected validation result: " + validationResult);
        return null;
    }
}
